import i18next from 'i18next';
import { apiAxios } from '@/lib/apiAxios';
export const fetchCampaignFeedback = async (publicId, params = {}) => apiAxios
    .get(`/campaigns/${publicId}/feedback`, { params })
    .then((response) => response.data);
export const exportCampaignFeedbackUrl = (publicId) => {
    const locale = (i18next.resolvedLanguage ?? i18next.language ?? 'en').split('-')[0];
    const safeLocale = ['en', 'fr', 'km'].includes(locale) ? locale : 'en';
    return `/api/v1/${safeLocale}/campaigns/${publicId}/feedback/export`;
};
